.indicator {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: none;
}

.neutral {
  background: var(--color-border-strong);
}

.success {
  background: var(--color-success);
}

.warning {
  background: var(--color-warning);
}

.danger {
  background: var(--color-danger);
}
